import React from 'react';
import { FiVideo, FiMessageCircle, FiShield, FiUsers, FiHeart, FiZap } from 'react-icons/fi';
import './Features.css';

const features = [
  { icon: <FiVideo />, title: 'HD Video Calls', desc: 'Crystal clear video calls with real-time connection. Meet face-to-face from anywhere.' },
  { icon: <FiHeart />, title: 'Smart Matching', desc: 'Filter by location, gender, and interests. Find your perfect match nearby.' },
  { icon: <FiMessageCircle />, title: 'Instant Chat', desc: 'Send messages, like profiles, and build connections before going on video calls.' },
  { icon: <FiZap />, title: 'Earn Money', desc: 'Get paid ₹15/min for every video call you receive. Withdraw earnings anytime.' },
  { icon: <FiShield />, title: 'Safe & Secure', desc: 'Verified profiles, screenshot protection, and encrypted calls for your privacy.' },
  { icon: <FiUsers />, title: 'Level System', desc: 'Level up by completing call hours. Higher levels mean higher earnings.' },
];

const Features = () => {
  return (
    <section className="features" id="features">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">Features</span>
          <h2>Everything you need to <span className="gradient-text">connect & earn</span></h2>
          <p>Slink combines dating, video calling, and earning into one seamless experience.</p>
        </div>
        <div className="features-grid">
          {features.map((f, i) => (
            <div className="feature-card" key={i}>
              <div className="feature-icon">{f.icon}</div>
              <h3>{f.title}</h3>
              <p>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
